import { makeStyles } from '@/styles/theme/tss-react';
import { brandColors } from '@/styles/theme/values/brandColors';

const useStyles = makeStyles({
  name: 'ActionDropdown',
})(({ spacing, breakpoints, type }) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    ...type['32_medium'],
    textWrap: 'pretty',
    [breakpoints.up('md')]: {
      ...type['44_medium'],
    },
    [breakpoints.up('md')]: {
      ...type['40_medium'],
    },
    [breakpoints.up('md')]: {
      ...type['56_medium'],
    },
  },
  subtitle: {
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    width: '100%',
    marginTop: spacing(0),
    color: brandColors.tintsNeutral20,
  },
}));

export default useStyles;
